import 'styles/default.css';
import 'styles/custom.css';
import * as CONFIG from 'config';
import { catalogOptions } from 'settings';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CatalogProvider } from 'Catalog/Catalog.context';
import Head from 'Head';
import Frame from 'Catalog/Frame';
import ScrollTop from 'uitils/ScrollTop';
import WheelControl from 'Catalog/WheelControl';

function Catalog() {
  return (
    <CatalogProvider {...catalogOptions}>
      <Head />
      <ScrollTop />
      <WheelControl />
      <Frame />
    </CatalogProvider>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter basename={`${CONFIG.BASE_NAME}`}>
        <Routes>
          <Route
            path='/'
            element={<Catalog />}
          />

          <Route
            path='/:lang'
            element={<Catalog />}
          />
          <Route
            path='/:lang/:pageNum'
            element={<Catalog />}
          />
          <Route
            path='*'
            element={<Catalog />}
          />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}
